import React, { useState } from 'react';
import { Building2, ChevronDown, CircleDot, Flag, Plus, Store } from 'lucide-react';
import './customFieldTable.css';
import { useCompanyLabels } from '../../context/CompanyContext';
const fieldIcons = {
  department: Building2,
  priorities: Flag,
  status: CircleDot,
  statuses: CircleDot,
  Status: CircleDot,
  storeId: Store,
  storeIdCustom: Store,
};

export default function CustomFieldTable({ fields = [], onAddField, disableAdd = false }) {
  const [open, setOpen] = useState(false);
  const { fieldLabel } = useCompanyLabels();

  return (
    <aside className={`custom-field-table${open ? ' is-open' : ''}`} aria-labelledby="custom-field-table-title">
      <button
        type="button"
        className="custom-field-table__summary"
        aria-expanded={open}
        aria-controls="custom-field-table-list"
        onClick={() => setOpen((current) => !current)}
      >
        <span className="custom-field-table__summary-text">
          <span id="custom-field-table-title" className="custom-field-table__title">
            Custom Fields
          </span>
          <span className="custom-field-table__description">
            Use these fields to show options from database table.
          </span>
        </span>
        <ChevronDown className="custom-field-table__chevron" size={16} strokeWidth={1.8} aria-hidden="true" />
      </button>

      <div id="custom-field-table-list" className="custom-field-table__list">
        {fields.map((field) => {
          const label = fieldLabel(field);
          const FieldIcon = fieldIcons[field.fieldKey] || fieldIcons[field.id] || Building2;
          return (
            <div className="custom-field-table__row" key={field.fieldKey ?? field.id}>
              <FieldIcon className="custom-field-table__field-icon" size={14} strokeWidth={1.5} aria-hidden="true" />
              <span className="custom-field-table__label">{label}</span>
              <button
                className="custom-field-table__add"
                type="button"
                aria-label={`Add ${label}`}
                title={disableAdd ? 'Resolve duplicate field first' : `Add ${label}`}
                disabled={disableAdd}
                onClick={() => {
                  if (disableAdd) return;
                  onAddField?.(field);
                }}
              >
                <Plus size={14} strokeWidth={2} aria-hidden="true" />
              </button>
            </div>
          );
        })}
      </div>
    </aside>
  );
}